import { render, staticRenderFns } from "./EDMTable.vue?vue&type=template&id=3de46b2c&scoped=true&"
import script from "./EDMTable.vue?vue&type=script&lang=js&"
export * from "./EDMTable.vue?vue&type=script&lang=js&"
import style0 from "./EDMTable.vue?vue&type=style&index=0&id=3de46b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de46b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
